import { useAsyncFn } from 'react-use';

import { useContextSelector } from 'use-context-selector';
import { getAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';

import { AuthContext } from '../../contexts/Auth.context';
import { useInAppRedirect } from '../useInAppRedirect/useInAppRedirect.hook';

type UseFacebookSignInReturnType = [
  {
    url?: string;
    error?: Error;
    loading: boolean;
  },
  () => void
];

export const useFacebookSignIn = (): UseFacebookSignInReturnType => {
  const host = useContextSelector(AuthContext, ({ webDomain }) => webDomain);

  const { open } = useInAppRedirect();

  return useAsyncFn(async () => {
    const url = await getAuthorisationURLWithQueryParamsAndSetState({
      providerId: 'facebook',
      authorisationURL: `${host}/auth/callback/facebook`,
    });

    open(url, {
      'User-Agent':
        'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36',
    });

    return url;
  });
};
